import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Float, MeshDistortMaterial, Icosahedron, Box, TorusKnot, Octahedron, Tetrahedron, Dodecahedron, Sphere } from '@react-three/drei';

const Shape = ({ type = 'sphere', color = '#6366f1' }) => {
    return (
        <Float speed={2} rotationIntensity={1.5} floatIntensity={2}>
            {type === 'sphere' && (
                <Icosahedron args={[1, 15]}>
                    <MeshDistortMaterial color={color} speed={3} distort={0.3} radius={1} />
                </Icosahedron>
            )}
            {type === 'standard-sphere' && (
                <Sphere args={[1, 32, 32]}>
                    <MeshDistortMaterial color={color} speed={2} distort={0.2} />
                </Sphere>
            )}
            {type === 'box' && (
                <Box args={[1.5, 1.5, 1.5]}>
                    <MeshDistortMaterial color={color} speed={2} distort={0.2} />
                </Box>
            )}
            {type === 'torus' && (
                <TorusKnot args={[1, 0.3, 128, 32]}>
                    <MeshDistortMaterial color={color} speed={4} distort={0.1} />
                </TorusKnot>
            )}
            {type === 'octahedron' && (
                <Octahedron args={[1, 0]}>
                    <MeshDistortMaterial color={color} speed={3} distort={0.2} />
                </Octahedron>
            )}
            {type === 'tetrahedron' && (
                <Tetrahedron args={[1, 0]}>
                    <MeshDistortMaterial color={color} speed={3} distort={0.2} />
                </Tetrahedron>
            )}
            {type === 'dodecahedron' && (
                <Dodecahedron args={[1, 0]}>
                    <MeshDistortMaterial color={color} speed={3} distort={0.2} />
                </Dodecahedron>
            )}
        </Float>
    );
};

const VisualCanvas = ({ type, color, height = "400px", showControls = true }) => {
    const isMobile = window.innerWidth < 1024;
    const [currentType, setCurrentType] = React.useState(type);

    if (isMobile) return null;

    const shapes = ['sphere', 'standard-sphere', 'box', 'torus', 'octahedron', 'tetrahedron', 'dodecahedron'];

    return (
        <div style={{ height, width: '100%' }} className="relative pointer-events-none">
            <Canvas camera={{ position: [0, 0, 5] }} dpr={[1, 1.5]} gl={{ powerPreference: "high-performance" }} className="pointer-events-none">
                <Suspense fallback={null}>
                    <ambientLight intensity={0.5} />
                    <pointLight position={[10, 10, 10]} />
                    <Shape type={currentType} color={color} />
                </Suspense>
            </Canvas>

            {showControls && (
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20 opacity-0 group-hover:opacity-100 transition-opacity">
                    {shapes.map(s => (
                        <button
                            key={s}
                            onClick={() => setCurrentType(s)}
                            className={`px-3 py-1 text-[8px] uppercase font-black tracking-widest rounded-full border transition-all ${currentType === s
                                ? 'bg-primary border-primary text-white'
                                : 'bg-white/5 border-white/10 text-white/50 hover:bg-white/10'
                                }`}
                        >
                            {s.replace('-', ' ')}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default VisualCanvas;
